import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FillHeightContainer, EmptyState } from '@steelbuy/ui-primitive';
import { RoutePath } from '../../router/Routes';
import { FOOTER_HEIGHT } from '../app-layout/app-footer/AppFooter';

export const MyRFQsEmptyState = () => {
    const { t } = useTranslation(['translation', 'uiDomain']);
    const navigate = useNavigate();

    return (
        <FillHeightContainer
            className="my-rfqs-list__empty-state-container"
            extraPadding={FOOTER_HEIGHT}
            minHeight={160}
        >
            <EmptyState
                caption={t('uiDomain:commonList.noListCaption')}
                description={t('application.myRFQ.noResultsDescription')}
                imgSrc="/assets/lib-ui-primitive/images/EmptyStateData.svg"
                button={{
                    label: t('application.myRFQ.noListingsCallToAction'),
                    onClick: () => navigate(RoutePath.CREATE_RFQ_WIZARD),
                }}
            />
        </FillHeightContainer>
    );
};
